// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ltm5jV5NV64tsn .uawrFupMce2L3f {
  display: block;
}
.ltm5jV5NV64tsn .kClrk4aJTxicyz {
  display: none;
}
.ltm5jV5NV64tsn:hover .uawrFupMce2L3f,
.ltm5jV5NV64tsn:active .uawrFupMce2L3f {
  display: none;
}
.ltm5jV5NV64tsn:hover .kClrk4aJTxicyz,
.ltm5jV5NV64tsn:active .kClrk4aJTxicyz {
  display: block;
}
.ltm5jV5NV64tsn:hover .kClrk4aJTxicyz svg {
  color: var(--tr-icon-star);
}
.ltm5jV5NV64tsn:active .kClrk4aJTxicyz svg {
  color: var(--ds-icon-disabled, #091e424f);
}
.dtqnjK66FNEeda .uawrFupMce2L3f {
  display: none;
}
.dtqnjK66FNEeda .kClrk4aJTxicyz {
  display: block;
}
.dtqnjK66FNEeda:hover .uawrFupMce2L3f {
  display: none;
}
.dtqnjK66FNEeda:hover .kClrk4aJTxicyz {
  display: block;
}
.dtqnjK66FNEeda:hover .kClrk4aJTxicyz svg {
  color: var(--tr-icon-star);
}
.dtqnjK66FNEeda:active .uawrFupMce2L3f {
  display: block;
}
.dtqnjK66FNEeda:active .kClrk4aJTxicyz {
  display: none;
}
.UBngiB3YliNv5H:hover .kClrk4aJTxicyz svg,
.UBngiB3YliNv5H:active .kClrk4aJTxicyz svg {
  color: var(--dynamic-icon);
}
.NXpI7m0KJX4QiX:hover .kClrk4aJTxicyz svg {
  color: var(--dynamic-icon);
}
`, ""]);
// Exports
export var starredBoardIcon = `ltm5jV5NV64tsn`;
export var starredIcon = `uawrFupMce2L3f`;
export var starIcon = `kClrk4aJTxicyz`;
export var unstarredBoardIcon = `dtqnjK66FNEeda`;
export var starredBoardIconCustomStarColor = `UBngiB3YliNv5H`;
export var unstarredBoardIconCustomStarColor = `NXpI7m0KJX4QiX`;
export default ___CSS_LOADER_EXPORT___;
